import { formatMediumDate } from "../../utils/displayFormat";

/**
 * Formats a calendar date ("yyyy-MM-dd") as the app's medium date without shifting
 * it across time zones: "2026-10-18" → "18. Okt. 2026" (de) / "Oct 18, 2026" (en-US).
 */
export const formatDateOnly = (value: string, language: string): string => {
  const [year, month, day] = value.split("-").map(Number);
  if (!year || !month || !day) return value;
  // Local noon of that calendar day: no zone offset can move it to the day before or after.
  return formatMediumDate(new Date(year, month - 1, day, 12), language);
};

/** Today's calendar date in the browser's time zone, as "yyyy-MM-dd". */
export const todayDateOnly = (): string => {
  const now = new Date();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  return `${now.getFullYear()}-${month}-${day}`;
};
